<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          Add Policy
        </v-card-title>
        <v-card-text>
          <div v-for="(level, index) in form.policies" :key="index">
            <v-row>
              <v-col cols="12" class="d-flex align-center">
                <h4 style="display: inline">Level {{ index + 1 }}</h4>
                <v-btn
                  v-if="form.policies.length > 1"
                  icon
                  class="ml-2"
                  color="red"
                  @click="removeLevel(index)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model.number="level.time"
                  label="Time(hours)"
                  type="number"
                  outlined
                  :error-messages="errors.time"
                ></v-text-field>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model.number="level.target_value"
                  label="Target(Gift value)"
                  type="number"
                  outlined
                  :error-messages="errors.target_value"
                ></v-text-field>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model.number="level.host_salary"
                  label="Host Salary($9.99)"
                  type="number"
                  outlined
                  :error-messages="errors.host_salary"
                ></v-text-field>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model.number="level.agent_salary"
                  label="Agent Salary($9.99)"
                  type="number"
                  outlined
                  :error-messages="errors.agent_salary"
                ></v-text-field>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model.number="level.bd_salary"
                  label="BD Salary($9.99)"
                  type="number"
                  outlined
                  :error-messages="errors.bd_salary"
                ></v-text-field>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model.number="level.total_salary"
                  label="Total Salary($9.99)"
                  type="number"
                  outlined
                  :error-messages="errors.total_salary"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>

          <v-btn class="mt-2 mb-4" color="secondary" @click="addLevel">
            <v-icon left>mdi-plus</v-icon>
            Add Next Level
          </v-btn>

          <v-divider class="my-5"></v-divider>

          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Policy
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "PolicyCreatePage",
  data() {
    return {
      form: {
        policies: [
          {
            time: 0,
            target_value: 0,
            host_salary: 0,
            agent_salary: 0,
            bd_salary: 0,
            total_salary: 0,
          },
        ],
      },
      isLoading: false,
    };
  },
  watch: {
    "form.policies": {
      handler(newPolicies) {
        newPolicies.forEach((policy) => {
          policy.total_salary =
            (Number(policy.host_salary) || 0) +
            (Number(policy.bd_salary) || 0) +
            (Number(policy.agent_salary) || 0);
        });
      },
      deep: true,
    },
  },
  methods: {
    addLevel() {
      this.form.policies.push({
        time: 0,
        target_value: 0,
        host_salary: 0,
        agent_salary: 0,
        bd_salary: 0,
        total_salary: 0,
      });
    },
    removeLevel(index) {
      this.form.policies.splice(index, 1);
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/policies", this.form);
        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.back();
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>
